import { useEffect, useState } from "react";
import type { AppProps } from "next/app";
import Head from "next/head";
import { useRouter } from "next/router";
import { appWithTranslation } from "next-i18next/pages";
import AppContext from "context/AppContext";
import useWindowDimentions from "hooks/useWindowDimentions";
import "../styles/globals.css";

const MyApp = ({ Component, pageProps }: AppProps) => {
  const router = useRouter();
  const { width, height } = useWindowDimentions();
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isLandscape, setIsLandscape] = useState<boolean>(false);

  const AnyComponent = Component as any;

  useEffect(() => {
    if (!!width && width < 1024) {
      setIsMobile(true);
      document.body.classList.add("mobile");
      document.body.classList.remove("desktop");
    } else {
      setIsMobile(false);
      document.body.classList.remove("mobile");
      document.body.classList.add("desktop");
    }

    if (!!width && !!height && width - 150 > height) {
      setIsLandscape(true);
      document.body.classList.add("landscape");
    } else {
      setIsLandscape(false);
      document.body.classList.remove("landscape");
    }
  }, [width, height]);

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1,viewport-fit=cover" />
        <meta name="google-site-verification" content={`${process.env.GOOGLE_SITE_VERIFICATION_ID}`}
        />

        <script
          defer
          data-website-id="58fb514d-b9b6-458a-8a61-8405cf41348c"
          src="https://umami.browserbite.io/script.js"
        ></script>
      </Head>


      <AppContext.Provider value={{ isMobile, isLandscape }}>
        <a href="#main-content" className="skipToContent">
          {router.locale === "de"
            ? "Zum Hauptinhalt springen"
            : "Skip to main content"}
        </a>
        <AnyComponent {...pageProps} />
      </AppContext.Provider>
    </>
  );
};

export default appWithTranslation(MyApp);
